
import { override } from 'flarum/extend'
import IndexPage from 'flarum/components/IndexPage'
import Field from '../common/models/Field'
import State from './states/State'

import Banners from './components/Banners'

app.initializers.add('fstln/flarum-ext-banners', () => {

  app.store.models.banners = Field

  app.banners = new State(app)

  // let title = app.forum.attribute('fstln-banners.title')
  override(IndexPage.prototype, 'hero', original => {

    return <Banners></Banners>

    return original()
  })
});